import { createFileRoute } from "@tanstack/react-router";
import { ChannelsSettings } from "@/features/settings/channels";
import { parseOAuthReturnSearch } from "@/features/settings/oauth-return";

export const Route = createFileRoute("/_app/settings/channels")({
  // ALP-77: the Instagram OAuth callback lands here with ?connected=<accountId> or ?error=<code>
  validateSearch: (raw: Record<string, unknown>) => parseOAuthReturnSearch(raw),
  head: () => ({ meta: [{ title: "Channels · Settings · Malfak" }] }),
  component: ChannelsSettings,
});
